import { AnyAction } from 'redux';
import { unitInitialState, UnitState } from '@reducers/initialState/unit';
import { unitActionTypes } from '@actions/actionTypes/unit';

export const unitReducer = (state = unitInitialState, action: AnyAction): UnitState => {
  switch (action.type) {
    case unitActionTypes.SET_UNITS: {
      return {
        ...state,
        units: action.payload,
      };
    }
    case unitActionTypes.SET_UNITS_TOTAL: {
      return {
        ...state,
        total: action.payload,
      };
    }
    case unitActionTypes.SET_UNITS_FILTERS: {
      return { ...state, unitsFilters: action.payload };
    }
    default: {
      return state;
    }
  }
};
